export default __webpack_public_path__ + "static/media/ExcelSVG.e6fa5ce2.svg";